/**
 * Card Async Reducer
 */

import { Actions } from "containers/CardSubscriptionAsync/store/Actions";
import { Reducer } from "redux";
import { getCardSubscriptionAsyncFormTranslations } from "root/shared/MultiLanguage";
import { IInputProps } from "root/store/CajitaStore";
import { ICardSubscriptionAsyncActionCreator } from "types/card_subscription_action_creator";
import { ICardSubscriptionAsyncFormProps } from "types/card_subscription_async_form_props";

const initialState: ICardSubscriptionAsyncFormProps = {
  isCardSubscriptionAsyncAvailable: true,
  isValid: false,
  totalAmount: 0,
  token: "",
  emailInput: {
    container: "card_subscription_async",
    value: "",
    classContainer: "inputContainer email-input",
    valid: false,
    dirty: false,
    classes: ["input"],
    inputPattern: /^[a-zA-Z0-9._+-@]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      isEmail: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "emailInput",
      type: "text",
    },
  },
  cardNumber: {
    value: "",
    classContainer: "inputContainer cardNumber-input top",
    dirty: false,
    valid: true,
    inputPattern: /^\d*$/,
    presentationPattern: /.{1,4}/g,
    separator: " ",
    classes: ["input", "input-cardNumber"],
    rules: {
      required: false,
      isCardNumber: true,
      maxLength: 18,
    },
    attributes: {
      id: "cardNumber",
      type: "text",
      name: "number",
    },
  },
  currency: "CLP",
  translation: getCardSubscriptionAsyncFormTranslations(),
};

const CardSubscriptionAsyncReducer: Reducer<ICardSubscriptionAsyncFormProps> = (
  state: ICardSubscriptionAsyncFormProps = initialState,
  action: ICardSubscriptionAsyncActionCreator
): ICardSubscriptionAsyncFormProps => {
  let input: IInputProps;

  switch (action.type) {
    case Actions.UPDATE_CARD_SUBSCRIPTION_ASYNC_INPUT:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: input,
      };
    case Actions.SET_CARD_SUBSCRIPTION_ASYNC_INPUT_DIRTY:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: {
          ...state[input.attributes.id],
          dirty: true,
        },
      };
    case Actions.SWITCH_CARD_SUBSCRIPTION_ASYNC_VALIDITY:
      return {
        ...state,
        isValid: !state.isValid,
      };
    case Actions.SET_CARD_SUBSCRIPTION_ASYNC_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    case Actions.DISABLE_CARD_SUBSCRIPTION_ASYNC_FORM:
      return {
        ...state,
        isCardSubscriptionAsyncAvailable: false,
      };
    case Actions.ENABLE_CARD_SUBSCRIPTION_ASYNC_FORM:
      return {
        ...state,
        isCardSubscriptionAsyncAvailable: true,
      };
    default:
      return state;
  }
};

export { CardSubscriptionAsyncReducer };



// WEBPACK FOOTER //
// ./src/containers/CardSubscriptionAsync/store/Reducer.tsx